import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ErrorAlert from "../../../common/ui/ErrorAlert.js";
import LocationLoader from "./LocationLoader.js";
import searchImage from "../../../images/search-icon.png";
import xImage from "../../../images/xmark-solid.png";
import backIcon from "../../../images/arrow-left-solid.png";
import Location from "./Location.js";

export default function LocationList(props) {
    const locationsMapped = props.locationList.filtered ? props.locationList.filtered.map((item) => {        
        return <Location key={item.locationNumber} data={item} handleSelectLocation={props.handleSelectLocation} currentLocation={props.currentLocation}/>
    }) : [];

    const loading = [...Array(5)].map((item, index) => <LocationLoader key={index} />);

    return(
        <Modal show={props.show} backdrop="static" keyboard={false}>
            {props.pickupOrDelivery.PickupDeliveryModal.ShowBackArrowPickupLocations && !props.currentLocation.LocationID ? 
            // Back Arrow - Pickup Locations
            <div className="modal-header justify-content-start">
                <button type="button" className="btn btn-light rounded-pill" onClick={props.handleBackPickupLocationsToMethodClick} >
                    <img src={backIcon} alt="Back" title="Back" style={{width: "20px"}}></img>
                </button>
                <h1 className="modal-title fs-5">&emsp;Locations</h1>
            </div> :
            // No Back Arrow - Pickup Locations
            <div className="modal-header">
                <h1 className="modal-title fs-5">Locations</h1>
                {props.currentLocation.LocationID && <button type="button" className="btn-close" aria-label="Close" onClick={props.handleCloseLocModal}></button>}
            </div>}
            <Modal.Body>
                <Form.Floating>
                    <span style={{position: "absolute", top: "0", left: "12px", zIndex: "3", cursor: "text"}} className="d-flex justify-content-center align-items-center h-100" onClick={props.handleFocusSearchLocation}>
                        <img src={searchImage} alt="Search" title="Search" style={{width: "18px"}}></img>
                    </span>
                    <Form.Control id="txtPostcodeLocSearch" ref={props.locationSearchInputRef} className="px-5" type="text" placeholder="eg. 2000" value={props.locationList.searchFilterText} onChange={props.handleSearchLocation} />
                    <label htmlFor="txtPostcodeLocSearch" className="ps-5">Enter Suburb or Postcode</label>
                    {props.locationList.showClearButton && <span style={{position: "absolute", top: "0", right: "10px", zIndex: "3", cursor: "text"}} className="d-flex justify-content-center align-items-center h-100" onClick={props.handleFocusSearchLocation}>
                        <Button variant="outline-light" type="button" className="border-0 d-flex align-items-center p-2" onClick={props.handleClearSearchLocation}>
                            <img src={xImage} alt="Clear" title="Clear" style={{width: "13px"}}></img>
                        </Button></span>}
                </Form.Floating>
                <div className="text-center mb-4"><a href="#" onClick={props.getGeoLocation}>Use current location</a></div>
                { props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue !== 'delivery' && 
                    <div className="bg-body-secondary rounded-3 px-3 py-1" style={{maxWidth: "max-content"}}>
                        <div className="d-flex align-items-center" style={{gap: "10px"}}>
                            <Form.Switch id="switchShowOpenStores" label="Show open stores only" className="my-auto" onChange={props.handleToggleOpenLocation} checked={props.locationList.showOpenOnly} />
                        </div>
                    </div>
                }
                { props.menuError.HasError && <div className="mt-3"><ErrorAlert message={props.menuError.ErrorMessage} /></div> }
                { props.locationLoading ? loading : props.locationError.HasError ? <div className="mt-3"><ErrorAlert message={props.locationError.ErrorMessage} /></div> : locationsMapped }
            </Modal.Body>
        </Modal>
    )
}